import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

import { Checkbox } from '@gamesb42/ui-kit';
import { Title3 } from '../Typography';
import { about } from './index';
import styles from './styles.module.scss';

// Типы валют
type CurrencyType = 'EUR' | 'USD';

// Конфигурация валют
const CURRENCY_OPTIONS: { value: CurrencyType; label: string }[] = [
  { value: 'EUR', label: 'EUR' },
  { value: 'USD', label: 'USD' },
];

// Переиспользуемый компонент для валюты
const CurrencyOption = observer(
  ({
    currency,
    label,
    checked,
    onToggle,
  }: {
    currency: CurrencyType;
    label: string;
    checked: boolean;
    onToggle: (currency: CurrencyType, checked: boolean) => void;
  }) => (
    <Checkbox
      checked={checked}
      onChange={(e) => onToggle(currency, e.target.checked)}
      className={currency === 'EUR' ? styles.labelCheckbox : undefined}
    >
      {label}
    </Checkbox>
  ),
);

const Currency = observer(() => {
  useEffect(() => {
    about.isStepIsValid[4] = !!about.currency.length;
  }, [about.currency]);

  // Функция для переключения валюты
  const toggleCurrency = (currency: CurrencyType, checked: boolean) => {
    if (checked) {
      // Добавляем валюту
      about.values.bank_details.push({
        currency,
        bank_name: '',
        account: '',
        swift: '',
        master:
          currency === 'EUR' ||
          !about.values.bank_details.find((item) => item.currency === 'EUR'),
      });
    } else {
      // Убираем валюту
      about.values.bank_details = about.values.bank_details.filter(
        (item) => item.currency !== currency,
      );
    }
  };

  return (
    <div>
      <Title3 className={styles.subTitle}>Your account currency*</Title3>
      <div className={styles.form}>
        {CURRENCY_OPTIONS.map(({ value, label }) => (
          <CurrencyOption
            key={value}
            currency={value}
            label={label}
            checked={about.currency.includes(
              value.toLowerCase() as 'eur' | 'usd',
            )}
            onToggle={toggleCurrency}
          />
        ))}
      </div>
    </div>
  );
});

export default Currency;
